<h4>
	{{ "day_time_range" | langVal }}{{ "day" | langVal }} {{ dayName | langVal }}
</h4>

@if (permsService?.owner_has_users) {
	<div class="row">
		<div class="col-12">
			<app-gen-autocomplete
				title_ph_lang="therapist"
				[fuzzySearchableClasses]="['sub_users']"
				[searchStr]="objNames?.user_id || ''"
				[error]="errors.user_id"
				autofocus
				tabindex="1"
				(chosenEvent)="chooseAutocomplete('user_id', $event)"
				(keyUp)="autocompleteKeyUp('user_id', $event)"
			>
			</app-gen-autocomplete>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<app-gen-autocomplete
				#locationFuzzyInput
				title_ph_lang="location"
				[fuzzySearchableClasses]="['locations']"
				tabindex="2"
				[searchStr]="objNames?.location_id || ''"
				[error]="errors.location_id"
				(chosenEvent)="chooseAutocomplete('location_id', $event)"
				(keyUp)="autocompleteKeyUp('location_id', $event)"
			>
			</app-gen-autocomplete>
		</div>
	</div>
}
<div class="d-flex gap-4">
	<div>
		<label>{{ "start_time_hour" | langVal }}</label>
		<app-time-picker
			[actualObj]="timeAllocationForm"
			[errors]="errors"
			fieldName="time"
			(changeEvent)="validateEntireForm()"
			[addonObject]="{ after: { icon: 'time' } }"
		>
		</app-time-picker>
	</div>
	<div>
		<label>{{ "end_time_hour" | langVal }}</label>
		<app-time-picker
			[actualObj]="timeAllocationForm"
			[errors]="errors"
			fieldName="time_to"
			(changeEvent)="validateEntireForm()"
			[addonObject]="{ after: { icon: 'time' } }"
		>
		</app-time-picker>
	</div>
</div>

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	@if (isUpdateMode) {
		<app-btn-ext
			btnClass="danger"
			text="delete"
			(clickEv)="delete()"
			[isSpin]="isSaving === 'delete'"
		/>
	}
	<app-btn-ext
		text="confirm"
		(clickEv)="submit()"
		[disabled]="!isFormSubmittable"
		[isSpin]="isSaving === 'save'"
	/>
</div>
